function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "icon-circle-crop");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  opacity: 0.8
}, /*#__PURE__*/React.createElement("circle", {
  cx: 18,
  cy: 18,
  r: 18
}));

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M23,21.5V14a1,1,0,0,0-1-1H9",
  fill: "none",
  stroke: "#fff",
  strokeMiterlimit: 10,
  strokeWidth: 1.5
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M13,14.5V22a1,1,0,0,0,1,1H27",
  fill: "none",
  stroke: "#fff",
  strokeMiterlimit: 10,
  strokeWidth: 1.5
});

var _ref6 = /*#__PURE__*/React.createElement("line", {
  x1: 13,
  y1: 11.5,
  x2: 13,
  y2: 9,
  fill: "none",
  stroke: "#fff",
  strokeMiterlimit: 10,
  strokeWidth: 1.5
});

var _ref7 = /*#__PURE__*/React.createElement("line", {
  x1: 23,
  y1: 27,
  x2: 23,
  y2: 24.5,
  fill: "none",
  stroke: "#fff",
  strokeMiterlimit: 10,
  strokeWidth: 1.5
});

const SvgIconCircleCrop = (_ref) => {
  let svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "aaced4f9-14e2-41eb-bd78-a9566a4aa330",
    "data-name": "Layer 1",
    viewBox: "0 0 36 36",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
};

const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconCircleCrop, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon-circle-crop.7bcda67b.svg";
export { ForwardRef as ReactComponent };